import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import CartoesCarregando from 'components/ui/cartoes-carregando';
import { useAuth } from 'context/AuthContext';
import { NotFound } from 'pages/NotFound';

/** Fila de validação do tutor e do coordenador. */
export const ROTA_DA_FILA_ECOA = '/validar-acao-ecoa';

/**
 * Perfil da rota `/acao-ecoa` (ECN-20, ECN-21): a Rede e quem não é da Ecoa veem "Página não encontrada", como hoje;
 * tutor e coordenador vão para a fila; só o integrante vê a página. Enquanto o `userInfo` não chega, o carregamento.
 */
export default function GuardaDoIntegranteEcoa({ children }: { children: ReactNode }) {
  const { user, userInfo } = useAuth();

  if (user?.extra?.rede) return <NotFound />;

  if (!userInfo) {
    return (
      <div className="mx-auto max-w-[1000px] px-4 py-6 lg:px-0">
        <CartoesCarregando />
      </div>
    );
  }

  if (!userInfo.ecoa) return <NotFound />;
  if (userInfo.ecoa === 'TUTOR' || userInfo.ecoa === 'COORDENADOR') return <Navigate to={ROTA_DA_FILA_ECOA} replace />;

  return <>{children}</>;
}
